import { FilterState } from 'stores/common/Filters';

export type CatalogFilterKeys =
  | 'rhlsTrial'
  | 'earlyAccess'
  | 'languages'
  | 'deliveryFormats'
  | 'roles'
  | 'taxonomyProducts'
  | 'taxonomyAudiences'
  | 'taxonomyTopics'
  | 'level';

/**
 * A map of filter keys to filter states.
 * Example: { categories: [{ key: '1', value: 'Math', count: 10, checked: false }] }
 */
export type CatalogFilters = {
  [K in CatalogFilterKeys]?: FilterState[];
};

export enum SortingType {
  Alphabetical = 'Title: Ascending',
  RevAlphabetical = 'Title: Descending',
  Newest = 'Newest',
  Oldest = 'Oldest',
  SKUAlphabetical = 'Course code: Ascending',
  SKURevAlphabetical = 'Course code: Descending',
}

export type CatalogEntryRoute = {
  routeName: string;
  routeParams: Record<string, string | undefined>;
};

export type CatalogEntryLink = CatalogEntryRoute & {
  href: string;
  navigate: () => void;
};

export type GetCatalogEntryRouteOptions = {
  /** When true, prefer in-content / continue routes over overview. */
  hasProgress?: boolean;
  /** Deep-link to a content page (course-like offerings only). */
  pageTag?: string;
};
